import { styled } from 'styled-components';

export const HiddenInput = styled.input`
  display: none;
`;
